export default "__VITE_ASSET__nF9KYvko__"